import { Col, Row, Spinner, Stack } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import {
  faCheckCircle,
  faXmarkCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { BackendStatusData } from 'src/models/GalenData/BackendStatus.model';
import { ModelStatus } from 'src/models/GalenData/DeviceDataView.model';
import { I18NextNS } from 'src/models/Language.model';

const modelNameObject: Record<
  keyof Omit<BackendStatusData, 'GlobalStatus' | 'SessionId'>,
  string
> = {
  GeneralQualityStatus: 'General Quality',
};

const modelStatusObject: Record<ModelStatus, string> = {
  [ModelStatus.NA]: 'Awaiting Upload',
  [ModelStatus.Triggered]: 'Queued',
  [ModelStatus.Running]: 'Running',
  [ModelStatus.Complete]: 'Complete',
  [ModelStatus.Failed]: 'Failed',
};

const ModelStack = ({
  name,
  status,
}: {
  name: keyof Omit<BackendStatusData, 'GlobalStatus' | 'SessionId'>;
  status: BackendStatusData;
}) => {
  const statusValue = status[name]?.value ?? ModelStatus.NA;

  const { t } = useTranslation(I18NextNS.COMMON);

  return (
    <Stack gap={3}>
      <Row>
        <Col sm={9}>
          {statusValue === ModelStatus.Complete ? (
            <FontAwesomeIcon icon={faCheckCircle} className="text-primary" />
          ) : statusValue === ModelStatus.Failed ? (
            <FontAwesomeIcon icon={faXmarkCircle} className="text-danger" />
          ) : (
            <Spinner variant="primary" size="sm" />
          )}
          <span className="ms-3">
            {t(`server.modelNameObject.${modelNameObject[name]}`)}
          </span>
        </Col>

        <Col
          sm={3}
          className={`${statusValue === ModelStatus.Failed ? 'text-danger' : 'text-gray-400'} text-end`}
        >
          {t(`server.modelStatusObject.${modelStatusObject[statusValue]}`)}
        </Col>
      </Row>
    </Stack>
  );
};

export default ModelStack;
